var map = {
	"./copy.svg": "8aac",
	"./input-btn/down.svg": "7d55",
	"./input-btn/search.svg": "9c6d",
	"./network-select/arrow.svg": "f2ea",
	"./network-select/bsc-selected.svg": "3c0a",
	"./network-select/bsc.svg": "60b9",
	"./network-select/eth-selected.svg": "3c06",
	"./network-select/eth.svg": "56b2",
	"./network-select/polygon-selected.svg": "3c85",
	"./network-select/polygon.svg": "3272",
	"./swap-btn/plus.svg": "0fc1",
	"./swap-btn/refresh.svg": "8acb",
	"./swap-btn/settings.svg": "0127",
	"./token-input/add.svg": "12f0",
	"./token-input/coins.svg": "57ea",
	"./token-input/info.svg": "f970",
	"./token-input/warning.svg": "f088"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";